import REPORT from "./Report";

export { REPORT };



// WEBPACK FOOTER //
// src/modules/screens/reporting/AgentHeatMap/components/index.js